import { render, staticRenderFns } from "./Sets.vue?vue&type=template&id=2845ac2e&"
import script from "./Sets.vue?vue&type=script&lang=js&"
export * from "./Sets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports